import { render } from "./CustomNotes.vue?vue&type=template&id=24166a8a&scoped=true&lang=pug"
import script from "./CustomNotes.vue?vue&type=script&lang=js"
export * from "./CustomNotes.vue?vue&type=script&lang=js"

import "./CustomNotes.vue?vue&type=style&index=0&id=24166a8a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24166a8a"]])

export default __exports__